// Some legacy npm packages used by the original CRA build (e.g. randomstring →
// safe-buffer) reach for Node's `Buffer` global at module-evaluation time.
// Vite externalises `buffer`, which leaves those modules trying to read
// `undefined.Buffer` and crashes the React tree before anything renders.
// Expose a browser-safe Buffer (and a minimal `process`) up front.
import { Buffer } from "buffer";
import process from "process";

if (typeof globalThis.Buffer === "undefined") {
  globalThis.Buffer = Buffer;
}
if (typeof globalThis.process === "undefined") {
  globalThis.process = process;
}
